import {InsightsBookmarkParams} from 'common/types/reports/bookmark';

export const EXPERIMENTS_KEY = `experiments`;
export const EXPOSURES_KEY = `exposures`;
export const STATSIG_KEY = `statsig`;
export const PROPERTIES_KEY = `properties`;

export function experimentQueryKeyForEntity(projectId: number, workspaceId: number, experimentId: string) {
  return [EXPERIMENTS_KEY, projectId, workspaceId, experimentId];
}

export function experimentQueryKeyForList(projectId: number, workspaceId: number) {
  return [EXPERIMENTS_KEY, projectId, workspaceId];
}

export function exposuresQueryKey({
  projectId,
  workspaceId,
  experimentId,
  bookmarkParams,
}: {
  projectId: number;
  workspaceId: number;
  experimentId: string;
  bookmarkParams?: InsightsBookmarkParams;
}) {
  return [EXPOSURES_KEY, projectId, workspaceId, experimentId, bookmarkParams];
}

export function statsigQueryKey({
  projectId,
  workspaceId,
  experimentId,
  bookmarkParams,
}: {
  projectId: number;
  workspaceId: number;
  experimentId: string;
  bookmarkParams?: InsightsBookmarkParams;
}) {
  return [STATSIG_KEY, projectId, workspaceId, experimentId, bookmarkParams];
}

export function propertiesQueryKey({
  projectId,
  workspaceId,
  experimentName,
}: {
  projectId: number;
  workspaceId: number;
  experimentName?: string;
}) {
  return [PROPERTIES_KEY, projectId, workspaceId, experimentName];
}
